import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import downloadTemplate from '../../../utilities/downloadCsv'
import { Button } from 'primereact/button';
import {
  API_COUNTRY_CODES_LIST,
  API_STATES_LIST,
  API_OPERATORS_LIST,
  API_TRUNKS_LIST
} from "../../../service/url";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {
  NUMBERS_FORMAT_TYPES,
  NUMBERS_FORMAT_FILE,
  NUMBERS_FORMAT_INDIVIDUAL,
  NUMBERS_TYPES,
  UPLOAD_NUMBER_DID,
  UPLOAD_NUMBER_OTHERS,
  SAMPLE_DATA_DID,
  SAMPLE_DATA_OTHERS,
  NUMBER_ROUTING_TYPE
 
} from "../../../utilities/constant";


function changeUploadFile(props, e) {
 
  const file = e.target.files[0];
  if (file && file.type === "text/csv") { 
    props.setUploadFile(file);
    props.setIsFileUpload(true);
  } else {
    props.setToastProps({
      message: "Please upload a CSV file.",
      type: "danger",
    });
    props.setUploadFile(null);
    props.setIsFileUpload(false);
  }
}

const getColumnsAndFilename = (numberType) => {
  let columns;
  let filename;
  let sample_data;

  if (numberType === 'DID') {
      columns = UPLOAD_NUMBER_DID;
      filename = `${numberType}-Upload.csv`;
      sample_data = SAMPLE_DATA_DID;
  } else if (numberType === 'VMN') {
      columns = UPLOAD_NUMBER_OTHERS;
      filename = `${numberType}-Upload.csv`;
      sample_data = SAMPLE_DATA_OTHERS;
  } else {
      columns = UPLOAD_NUMBER_OTHERS;
      filename = `${numberType}-Upload.csv`;
      sample_data = SAMPLE_DATA_OTHERS;

  }

  return { columns, filename, sample_data };
};





function RenderFormatTypeFields(props) {
  props = props["props"];
  
  // Determine currency symbol and cost display based on category and country
  const isFree = props.category === 'Free';
  const isIndia = props.countryCodeId === 'IN';
  const currencySymbol = isIndia ? '₹' : '$';
  const displayCost = isFree ? '0' : (props.cost || '');
  const callingCodePrefix = props.countryCallingCode || '';
  
  if (props.formatType === NUMBERS_FORMAT_INDIVIDUAL) {
    return (
      <>
          <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="">{props.numberType ? props.numberType : "Number Type"}: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <div className="input-group">
            {callingCodePrefix ? (
              <span className="input-group-text">+{callingCodePrefix}</span>
            ) : null}
            <Form.Control
              type="text"
              placeholder={props.numberType ? props.numberType : "Number Type"}
              id="did"
              value={props.did}
              maxLength={10}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                props.setDid(value);
              }}
              required
            />
          </div>
        </Form.Group>

        <Form.Group className="col-md-3 form-group mb-0">
          <Form.Label htmlFor="">Cost: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {isFree ? (
            <div className="input-group">
              <span className="input-group-text bg-light" style={{ cursor: 'not-allowed' }}>{currencySymbol}</span>
              <Form.Control
                type="text"
                placeholder="Cost"
                id="cost"
                value="0"
                readOnly
                disabled
                className="bg-light"
                style={{ cursor: 'not-allowed' }}
                required
              />
            </div>
          ) : (
            <div className="input-group">
              <span className="input-group-text">{currencySymbol}</span>
              <Form.Control
                type="number"
                placeholder="Cost"
                id="cost"
                value={props.cost}
                onChange={(e) => {
                  const value = e.target.value;
                  if (Number(value) >= 0) {
                    props.setCost(value);
                  } else {
                    props.setCost(0);
                  }
                }}
                required
              />
            </div>
          )}
          </Form.Group>

        
      </>
    );
  } else if (props.formatType === NUMBERS_FORMAT_FILE) {
    return (
      <>
        <Form.Group className="col-md-8 form-group mb-1">
          <Form.Label htmlFor="">File: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Control
            type="file"
            placeholder="Bulk Upload Numbers"
            id="uploadNumbers"
            onChange={(e) => changeUploadFile(props, e)}
            accept=".csv"
            required
          />
        </Form.Group>
        <Form.Group className="col-md-4 form-group mb-1 d-flex align-items-end">
        {props.numberType && (
          <Button variant="btn btn-primary btn-sm" onClick={(event) => {
            const { columns, filename, sample_data } = getColumnsAndFilename(props.numberType);
            downloadTemplate(event, columns, filename, null ,sample_data);
          }}>Download Template</Button>
        )}
        </Form.Group>
      </>
    );
  }
  return <></>;
}

export default function RenderNumberForm(props) {
  const [countryCodesList, setCountryCodesList] = useState([]);
  const [stateCodeList, setStateCode] = useState([]);
  const [operatorsList, setOperatorsList] = useState([]);
  const [trunksList, setTrunksList] = useState([]);


  useEffect(() => {

    getApiCall(API_COUNTRY_CODES_LIST, {})
      .then(onCountryCodesListSuccess)
      .catch(onError);

    getApiCall(API_OPERATORS_LIST, {})
      .then(onOperatorListSuccess)
      .catch(onError);
      
    getApiCall(API_TRUNKS_LIST, {})
      .then(onTrunksListSuccess)
      .catch(onError);

  }, []);

  function onOperatorListSuccess(resp) {
    setOperatorsList(resp);
  }

  function onTrunksListSuccess(resp) {
    setTrunksList(resp);
  }

  useEffect(() => {
    if (props.countryCodeId) {
      const params = {
        countryCode: props.countryCodeId,
      };
      postApiCall(API_STATES_LIST, params)
        .then((response) => {
          setStateCode(response);
        })
        .catch((error) => console.error("Error while fetching states:", error));
      
      // Auto-set currency based on country code
      // India (IN) -> INR, Others -> USD
      if (props.countryCodeId === 'IN') {
        props.setCurrency('INR');
      } else if (props.countryCodeId) {
        props.setCurrency('USD');
      }
    }
  }, [props.countryCodeId]);

  function onCountryCodesListSuccess(resp) {
    setCountryCodesList(resp);
  }


  function onError(err) {
    console.log(err);
  }

  const selectedCountry = countryCodesList.find(
    (country) => country.code === props.countryCodeId
  );
  const countryCallingCode = String(selectedCountry?.calling_code || "")
    .trim()
    .replace(/^\+/, "");

  return (
    <>
      <div className="row g-4">
     
        <Form.Group className="col-md-4 form-group mb-1" >
          <Form.Label htmlFor="">Format Type: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="formatType"
            value={props.formatType}
            className="p-2"
            onChange={(e) => props.setFormatType(e.target.value)}
            required
          >
            <option value={""}>Select Format Type</option>
            {NUMBERS_FORMAT_TYPES.map(function (val, idx) {
              return (
                <option key={idx} value={val.value}>
                  {val.label}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>


        {props.formatType === NUMBERS_FORMAT_INDIVIDUAL && (
          <Form.Group className="col-md-4 form-group mb-1">
            <Form.Label htmlFor="">Number Routing</Form.Label>
            <Form.Select
              id="numberRouteType"
              className="p-2"
              value={props.numberRoutingType}
              onChange={(e) => props.setNumberRoutingType(e.target.value)}
              required
            >
              <option value="">Select Number Routing</option>
              {NUMBER_ROUTING_TYPE.map((number_routing_type, idx) => (
                <option key={idx} value={number_routing_type.value}>
                  {number_routing_type.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        <Form.Group className="col-md-4 form-group mb-1">
          <Form.Label htmlFor="">Number Type: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          <Form.Select
            id="numberType"
            value={props.numberType}
            className="p-2"
            onChange={(e) =>props.setNumberType(e.target.value)}
            required
          >
             <option value={""}>Select Number Type</option>
            {NUMBERS_TYPES.map(function(val,idx){
              return(
                <option key ={idx} value={val.value}>
                  {val.label}
                </option>
              )
            })}
          </Form.Select>
        </Form.Group>

        {/* Show Country Code for other cases (non-DID or non-FREE) */}
        {(props.formatType === NUMBERS_FORMAT_INDIVIDUAL) && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="">Country: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="countryCodeId"
              required
              value={props.countryCodeId}
              className="p-2"
              onChange={(e) => props.setCountryCodeId(e.target.value)}
            >
              <option value={""}>Select Country Code</option>
              {countryCodesList.map(function (val, idx) {
                return (
                  <option key={idx} value={val.code}>
                    {val.name}{` (${val.code})`}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        )}

        {(props.numberType === "DID" && props.formatType === NUMBERS_FORMAT_INDIVIDUAL) && (
          <Form.Group className="col-md-4 form-group mb-1">
            <Form.Label htmlFor="">State: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="stateCode"
              required
              value={props.stateCode}
              className="p-2"
              onChange={(e) => props.setStateCode(e.target.value)}
            >
              <option value={""}>Select State Code</option>
              {stateCodeList && stateCodeList.map(function (val, idx) {
                return (
                  <option key={idx} value={val.isoCode}>
                    {val.name}{` (${val.isoCode})`}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        )}
        {props.numberType === 'DID' && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="">Category: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="category"
              value={props.category}
              className="p-2"
              onChange={(e) =>props.setCategory(e.target.value)}
              required
            >
              <option value="">Select Category</option>
              <option value="Free">Free</option>
              <option value="Paid">Paid</option>
            </Form.Select>
          </Form.Group>
        )}
        {(props.numberType === 'DID' || props.numberType === 'VMN' ||  props.numberType === 'TOLL FREE') && ( //
          <Form.Group className="col-md-2 form-group mb-1">
            <Form.Label htmlFor="">Currency: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="currency"
              value={props.currency}
              className="p-2"
              onChange={(e) => props.setCurrency(e.target.value)}
              required
              disabled={props.countryCodeId ? true : false}
              style={props.countryCodeId ? { cursor: 'not-allowed', backgroundColor: '#e9ecef' } : {}}
            >
              <option value="">Select Currency</option>
              <option value="INR">INR</option>
              <option value="USD">USD</option>
            </Form.Select>
          </Form.Group>
        )}
        {props.numberType === 'DID' && (
          <Form.Group className="col-md-3 form-group mb-1">
            <Form.Label htmlFor="">Trunks: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
            <Form.Select
              id="trunks"
              value={props.trunks}
              className="p-2"
              onChange={(e) => props.setTrunks(e.target.value)}
              required
            >
              <option value="">Select Trunks</option>
              {trunksList.map(function (val, idx) {
                return (
                  <option key={idx} value={val.id}>
                    {val.name}
                  </option>
                );
              })}
            </Form.Select>
          </Form.Group>
        )}
        {(props.formatType === NUMBERS_FORMAT_INDIVIDUAL) && (
        <Form.Group className="col-md-3 form-group mb-1">
          <Form.Label htmlFor="">Operator: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
        <Form.Select
          id="operator"
          placeholder="Operator"
          className="p-2"
          required
          value={props.operator}
          onChange={(e) => props.setOperator(e.target.value)}
        >
          <option value={""}>Select Operator</option>
          {operatorsList.map(function (val, idx) {
            return (
              <option key={idx} value={val.name}>
                {val.name}
              </option>
            );
          })}
        </Form.Select>
        </Form.Group>
        )}
     
        <RenderFormatTypeFields props={{ ...props, countryCallingCode }} />
      </div>
      {props.formatType == NUMBERS_FORMAT_FILE && (
        <div
          style={{
            background: "#FFF8C6",
            color: "#6B4E16",
            padding: "14px 16px",
            borderRadius: "8px",
            border: "1px solid #FFE08A",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: "6px" }}>
            ⚠️ Important Information
          </div>

          <ul style={{ margin: 0, paddingLeft: "18px" }}>
            {props.numberType === 'DID' && (
            <li>
              If the <b>Category</b> is set to <b>Free</b>, the <b>Cost</b> value in the template must be
              <b> 0 (Zero)</b>.
            </li>
            )}

            <li>
              Set <b>Number Routing</b> in the template using <b>incoming</b>, <b>outgoing</b>, or <b>both</b>.
            </li>

            <li>
              To correctly fill the template, refer to the dropdown values for <b>Country Code</b> and <b>State Code</b> by selecting <b>Format Type</b> as <b>Individual</b>.
            </li>
          </ul>
        </div>
      )}
      <hr />
    </>
  );
}
